import { BizcoverIndiaBrandMark } from "../Branding/BizcoverIndiaBrandMark";

export interface AuthHeroPanelProps {
  /** Optional full-bleed background image URL (e.g. from webapp assets). When omitted, uses gradient only. */
  backgroundImageUrl?: string;
}

export const AuthHeroPanel = ({ backgroundImageUrl }: AuthHeroPanelProps) => {
  const bgStyle = backgroundImageUrl
    ? {
        backgroundImage: `url(${backgroundImageUrl})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }
    : {
        background:
          "linear-gradient(135deg, #ea580c 0%, #c2410c 40%, #991b1b 100%)",
      };

  return (
    <div
      className="relative flex min-h-full w-full flex-col px-8 py-12 md:px-12 lg:px-16"
      style={bgStyle}
    >
      {/* Branding — matches marketplace header wordmark */}
      <BizcoverIndiaBrandMark variant="hero" />
    </div>
  );
};
